export const blurActiveElement = () => {
  const inputElement = document.activeElement as HTMLInputElement | undefined;
  inputElement?.blur();
};
